import React, { useState } from 'react';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { GoalType, ICustomTheme } from 'interfaces';
import { GOAL } from 'constants/challenges';
import ConditionsModal from '../ConditionsModal';
import * as S from './styles';

type ConditionsType = {
  children: JSX.Element | JSX.Element[];
  disabled: boolean;
  goalType: GoalType;
  modalProps: {
    additionalInformation: string;
    calculationRules?: string[];
    conditions?: string[];
    eligibilityRequirements?: string[];
    participantsProfiles?: string[];
  };
};

const Conditions = ({
  children,
  disabled,
  goalType,
  modalProps,
}: ConditionsType): JSX.Element => {
  const { t } = useTranslation();
  const [showMoreConditions, setShowMoreConditions] = useState(true);
  const [isOpenModalConditions, setIsOpenModalConditions] = useState(false);
  const theme: ICustomTheme = useTheme();
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));

  const checkOverflow = (element: HTMLDivElement): void => {
    if (!element) {
      return;
    }

    const isOverflowing =
      element.clientWidth < element.scrollWidth ||
      element.clientHeight < element.scrollHeight;
    setShowMoreConditions(isOverflowing);
  };

  return (
    <Grid item lg={goalType === GOAL.GENERIC ? 5 : 6}>
      <S.ConditionTitle
        variant={isDownSm ? 'body2' : 'h4'}
        isDisabled={disabled}
      >
        {t('challenges.detail.goals_and_rewards.conditions.title')}
      </S.ConditionTitle>

      <S.ConditionsWrapper isDisabled={disabled}>
        <S.ConditionsContainer
          ref={checkOverflow}
          maxHeight={goalType === GOAL.CUSTOM ? 280 : 200}
        >
          {children}
        </S.ConditionsContainer>

        {showMoreConditions && (
          <S.AllConditions
            onClick={() => setIsOpenModalConditions(true)}
            role="button"
            variant={isDownSm ? 'caption' : 'body2'}
          >
            <S.SeeMoreIcon />
            {t('challenges.detail.goals_and_rewards.conditions.all_conditions')}
          </S.AllConditions>
        )}

        <ConditionsModal
          goalType={goalType}
          open={isOpenModalConditions}
          setOpenModal={setIsOpenModalConditions}
          {...modalProps}
        />
      </S.ConditionsWrapper>
    </Grid>
  );
};

export default Conditions;
